interface PdfViewerProps {
  src: string;
  title: string;
}

function PdfViewer({ src, title }: PdfViewerProps) {
  const viewUrl = `${src}#toolbar=0&navpanes=0&scrollbar=1`;

  return (
    <div className="mt-6">
      <p className="text-xs uppercase tracking-[0.2em] text-[#C41E3A]">Presentación (solo lectura)</p>
      <div
        className="relative mt-3 overflow-hidden border border-[#1E3A5F]/15 bg-[#EDE6D9]"
        onContextMenu={(event) => event.preventDefault()}>

        <iframe
          title={title}
          src={viewUrl}
          className="h-[70vh] w-full" />

        <div className="pointer-events-none absolute right-2 top-2 bg-[#F4EFE6]/90 px-2 py-1 text-[10px] uppercase tracking-wide text-[#1E3A5F]/55">
          Sin descarga
        </div>
      </div>
      <p className="mt-2 text-xs text-[#1E3A5F]/50">El PDF se visualiza en el aula. 

      </p>
    </div>);

}

export default PdfViewer;